const route = {
  main: '/',
  login: '/login',
  contact: '/contact',
  messages: '/messages'
}

export default route



// WEBPACK FOOTER //
// ./src/routes-types.js